import { createRequest, RequestConfig } from '../../../core/libs/api';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/reset_password',
};
type Params =
  | { phone: string }
  | { phone: string; code: string; password: string };
export const resetPasswordRequest = (data: Params) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(data),
  });
